<template>
  <div>
    <h3 class="pb-5 table-header" v-if="headerTitle != ''">
      {{ headerTitle }} <span v-if="required" style="color: #db2828">*</span>
    </h3>
    <!-- TABLE ACTION ROW -->
    <div>
      <div
        class="flex flex-wrap items-center"
        v-bind:class="[isShowPaginate ? 'justify-between' : 'justify-end']"
      >
        <!-- ITEMS PER PAGE -->
        <div
          class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left"
          v-if="isShowPaginate"
        >
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{ (currentPage - 1) * paginationPageSize + 1 }}
                -
                {{ sectionLastItem }}
                of {{ totalRows }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="size in paginationSizes"
                :key="size"
                @click="onPageSizeChange(size)"
              >
                <span>{{ size }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div
          class="
            flex flex-wrap
            items-center
            justify-end
            ag-grid-table-actions-right
          "
          v-if="isShowSearch"
        >
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()"
          >Export as CSV</vs-button
        > -->
          <vs-input
            class="table-search"
            v-model="searchQuery"
            @input="updateSearchQuery"
            placeholder="Search"
            icon="search"
            icon-after="true"
          />
        </div>
      </div>
      <div class="w-100 text-center" v-show="isLoadingData">
        <spinner />
      </div>
      <div class="aavv overflow-x-scroll lg:overflow-auto relative w-full">
        <ag-grid-vue
          v-show="!isLoadingData"
          ref="agGridTable"
          :animateRows="true"
          :columnDefs="columnDefsData"
          :defaultColDef="defaultColDef"
          :enableRtl="$vs.rtl"
          :floatingFilter="false"
          :gridOptions="gridOptions"
          :pagination="isShowPaginate"
          :paginationPageSize="paginationPageSize"
          :rowData="rawData"
          :suppressPaginationPanel="true"
          :suppressRowClickSelection="isShowCheckBox"
          class="ag-theme-material w-100 my-4 ag-grid-table setwidth"
          :style="tableStyle"
          :domLayout="tableHeightMode"
          colResizeDefault="shift"
          rowSelection="multiple"
          @selection-changed="onSelectionChanged"
        >
        </ag-grid-vue>
      </div>
      <vs-pagination
        v-if="isShowPaginate"
        :total="totalPages"
        color="secondary"
        :max="maxPageNumbers"
        v-model="currentPage"
        :total-visible="7"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { debounce } from 'lodash'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Spinner from '@/components/Spinner.vue'

export default {
  name: 'table-component',
  components: {
    AgGridVue,
    Spinner
  },
  data() {
    return {
      searchQuery: '',
      gridOptions: {
        onRowClicked: this.onRowClicked,
        rowHeight: 70,
        headerHeight: this.isShowHeaderTable ? 70 : 0
      },
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        resizable: true
      },
      isCheckboxSelection: false,
      //tableStyle: '',
      tableMinHeight: 150, // when we use mode autoHeight ag will set min-height 150px
      selectedPageSize: this.paginationPageSize,
      minimumItemScrollable: 20, // TODO: use arbitary number for now, need to figure out how to detect whether user is having vertical scrollbar active or not
      pageCheckList: '',
      serverCurrentPage: 0,
      isLoadingData: false,
      scrollBottomFired: false
    }
  },
  props: {
    headerTitle: {
      type: String,
      default: ''
    },
    columnDefs: {
      type: Array,
      required: true
    },
    isShowPaginate: {
      type: Boolean,
      default: false
    },
    isShowSearch: {
      type: Boolean,
      default: true
    },
    rawData: {
      type: Array,
      required: true
    },
    isShowCheckBox: {
      type: Boolean,
      default: false
    },
    isShowHeaderTable: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array
    },
    onRowClicked: {
      type: Function,
      default: () => {}
    },
    isServerPagination: {
      type: Boolean,
      default: false
    },
    defaultPaginationSize: {
      type: Number
    },
    paginationSizes: {
      type: Array,
      default: () => [20, 50, 100, 150]
    },
    serverTotalRows: {
      type: Number,
      default: 0
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    enableInfiniteScroll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sectionLastItem() {
      return this.totalRows < this.currentPage * this.paginationPageSize
        ? this.totalRows
        : this.currentPage * this.paginationPageSize
    },
    totalRows() {
      if (this.isServerPagination) {
        return this.serverTotalRows
      }
      return this.rawData.length
    },
    tableHeightMode() {
      return this.autoHeight ? 'autoHeight' : 'normal'
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else if (this.defaultPaginationSize) return this.defaultPaginationSize
      else if (this.paginationSizes.length > 0) return this.paginationSizes[0]
      // set default pagination choice
      else return 50
    },
    totalPages() {
      if (this.isServerPagination && this.serverTotalRows > 0) {
        return Math.ceil(this.serverTotalRows / this.paginationPageSize)
      }

      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 1
    },
    totalPageItems() {
      if (this.enableInfiniteScroll) {
        return this.rawData.length
      }
      if (this.currentPage >= this.totalPages) {
        return this.rawData.length === this.paginationPageSize
          ? this.rawData.length
          : this.rawData.length % this.paginationPageSize
      }
      return this.paginationPageSize
    },
    currentPage: {
      get() {
        if (this.isServerPagination) return this.serverCurrentPage + 1
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        return 1
      },
      set(val) {
        if (val === this.currentPage) return
        if (this.isServerPagination) {
          this.serverCurrentPage = val - 1
          this.onServerPaginationChanged(val, this.paginationPageSize)
        } else {
          this.gridApi.paginationGoToPage(val - 1)
        }
      }
    },
    tableStyle() {
      let tableStyle = ''
      if (!this.autoHeight) {
        return
      }

      const totalHeight = this.totalPageItems * this.gridOptions.rowHeight
      const bufferHeight = this.isShowCheckBox ? 50 : 15

      if (totalHeight < 150) {
        tableStyle += ` min-height: ${this.tableMinHeight + bufferHeight}px;`
      }

      tableStyle += ` height: ${totalHeight + bufferHeight}px;`
      return tableStyle
    },
    columnDefsData() {
      return this.isShowCheckBox
        ? [
            {
              headerName: ' ',
              maxWidth: 50,
              checkboxSelection: true,
              headerCheckboxSelection: true,
              headerCheckboxSelectionFilteredOnly: true,
              suppressSizeToFit: false
            },
            ...this.columnDefs
          ]
        : this.columnDefs
    }
  },
  methods: {
    onServerPaginationChanged(page, limit) {
      this.isLoadingData = true

      const offset = (page - 1) * limit

      this.$emit('pagination-changed', { limit, offset })
    },
    onPageSizeChange(size) {
      this.gridApi.paginationSetPageSize(size)
      if (this.isServerPagination) {
        this.onServerPaginationChanged(this.currentPage, size)
      }
    },
    updateSearchQuery(val) {
      if (!this.isServerPagination) {
        this.gridApi.setQuickFilter(val)
        this.$emit('update-search', val)
      } else {
        this.debouncedFireUpdateSearch()
      }
    },
    onSelectionChanged() {
      this.isCheckboxSelection = true
      const selectedRows = this.gridApi.getSelectedRows()
      this.$emit('input', selectedRows)
      this.$nextTick(() => {
        this.isCheckboxSelection = false
      })
    },
    onInnerWidthChanged() {
      this.gridApi.sizeColumnsToFit()
    },
    setSelectedEachNode() {
      this.gridApi.forEachNode(node => {
        node.setSelected(
          this.value.findIndex(data => node.data.id === data.id) !== -1
        )
      })
    },
    handleScroll(event) {
      if (
        event.target.scrollingElement.scrollTop +
          event.target.scrollingElement.offsetHeight >
          this.$el.scrollHeight - this.gridOptions.rowHeight * 5 &&
        !this.scrollBottomFired
      ) {
        this.$emit('scroll-to-bottom', { hasEnoughData: true })
        this.scrollBottomFired = true
      }
    }
  },
  watch: {
    value() {
      if (this.isShowCheckBox && !this.isCheckboxSelection) {
        this.setSelectedEachNode()
      }
    },
    rawData: {
      handler() {
        this.isLoadingData = false
        this.scrollBottomFired = false
        if (
          this.enableInfiniteScroll &&
          this.rawData.length < this.minimumItemScrollable
        ) {
          this.$emit('scroll-to-bottom', { hasEnoughData: false })
          this.scrollBottomFired = true
        }
      },
      deep: true
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        '.ag-header-container'
      )
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }

    if (!this.columnDefs.some(columnDef => columnDef.flex !== undefined)) {
      window.onresize = this.onInnerWidthChanged
      this.gridApi.sizeColumnsToFit()
    }
  },
  created() {
    if (this.isShowSearch) {
      this.debouncedFireUpdateSearch = debounce(() => {
        this.isLoadingData = true
        this.$emit('update-search', this.searchQuery)
      }, 500)
    }

    if (this.enableInfiniteScroll) {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  destroyed() {
    if (this.enableInfiniteScroll) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
}
</script>

<style lang="scss">
.ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after {
  color: rgba(var(--vs-secondary), 1);
}

::-webkit-scrollbar {
  width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #dae1e7;
  radius: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 820px) {
  .setwidth {
    min-width: 1200px;
  }
}
</style>
